import React from 'react';
import Zoom from 'react-medium-image-zoom';

const title = "Purchase by Product";
const description = `The Purchase By Product report is a specialized procurement tool designed to give management a detailed view of all acquisitions categorized by the item itself, clarifying **which specific product** was purchased, the **total quantity** and **cost incurred**, and most importantly, listing **all the suppliers** from whom that product was sourced over a particular time frame. This report is crucial for **inventory management**, cost control, and strategic sourcing, as it allows a business to quickly analyze price variations for the same item across different vendors, identify the total volume of a particular stock item acquired, and evaluate supplier reliability for critical goods, all of which support cost-saving negotiations and optimized purchasing strategies.`;

const images = [
    '/images/reports/purchase-by-product/purchase-by-product.png', // 0
];


const PurchaseBySupplier: React.FC = () => {

    return (
        <div className="max-w-4xl lg:max-w-5xl min-h-screen bg-gray-50 flex gap-2">
            <div className="overflow-auto mx-auto flex-2">

                <div className="mb-6">
                    <h1 className="text-3xl font-bold pt-4 text-gray-900">
                        {title}
                    </h1>
                    <p className="text-gray-600 mt-4">
                        {description}
                    </p>
                    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 my-6">
                        <Zoom>
                            <img
                                src={images[0]}
                                alt={title}
                                className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm mx-auto"/>
                        </Zoom>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PurchaseBySupplier;
